module.exports = __webpack_public_path__ + "img/67.4842c6f9.jpg";